export const testimonials = [
  {
    name: "Sophie Laurent",
    role: "Analyste de Données",
    quote: "Le hipobuy spreadsheet a complètement transformé ma façon de gérer les données. L'automatisation des processus m'a fait gagner des heures chaque semaine. Je ne peux plus m'en passer.",
    imageSeq: "testimonial-1",
    rating: 5,
  },
  {
    name: "Marc Duval",
    role: "Entrepreneur",
    quote: "J'utilisais Excel depuis 10 ans sans imaginer qu'il existait mieux. Le hipobuy spreadsheet est plus intuitif, plus rapide et surtout plus puissant pour le suivi business.",
    imageSeq: "testimonial-2",
    rating: 5,
  },
  {
    name: "Claire Moreau",
    role: "Consultante SEO",
    quote: "Pour le tracking SEO et l'analyse de données, le hipobuy spreadsheet est imbattable. Les templates prêts à l'emploi m'ont permis de démarrer en quelques minutes.",
    imageSeq: "testimonial-3",
    rating: 4,
  },
];